import React from 'react';
import { Text, View } from 'react-native';
import DefaultScreen from '@components/Global/DefaultScreenView';

const ProjectTemplate = () => {
  return (
    <DefaultScreen scrollDisabled>
      <View style={{ flex: 1 }}>

      </View>
    </DefaultScreen>
  )
}

export default ProjectTemplate;